
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recentBundles",
      function () {
        return require("private-next-pages/recentBundles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recentBundles"])
      });
    }
  